export function isPackageEligibleForQrPdf(pkg) {
  return !!(pkg && pkg.scan_code_type !== "barcode");
}

export function deliveryNoteIsAllBarcodePackages(packages) {
  const list = Array.isArray(packages) ? packages : [];
  return list.length > 0 && list.every((p) => p.scan_code_type === "barcode");
}

function ordersFromPathwayStop(stop) {
  return [
    ...(stop?.Orders || []),
    ...(stop?.additionalCustomers || []).flatMap((ac) => ac?.Orders || []),
  ];
}

export function getRouteScanPrintAvailability(pathway, supplierLocationId) {
  if (!Array.isArray(pathway)) {
    return { canPrintAllQr: false, canPrintSupplierQr: false };
  }
  const hasEligible = (orderFilter) => {
    for (const stop of pathway) {
      for (const order of ordersFromPathwayStop(stop)) {
        if (orderFilter && !orderFilter(order)) continue;
        for (const dn of order?.DeliveryNotes || []) {
          for (const pkg of dn?.Packages || []) {
            if (isPackageEligibleForQrPdf(pkg)) return true;
          }
        }
      }
    }
    return false;
  };
  return {
    canPrintAllQr: hasEligible(null),
    canPrintSupplierQr:
      supplierLocationId != null &&
      hasEligible((o) => o.supplier_location_id === supplierLocationId),
  };
}
